<template>
  
  <div v-if="appSettings.school_app_footer" class="footer">
        <img v-if="!imgError" :src="appSettings.school_app_footer" @error="imgLoadError">
        <div class="no-img" v-if="imgError">{{appSettings.school_app_footer}}</div>
  </div>
 
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'app-footer',
  props:{
  },
  data(){
    return {
      imgError:false,
    }
  },
  components: {
   
  },
  computed:{
      ...mapState([
    'appSettings'
    ]),
  },
  methods:{
    
    imgLoadError(){
      
      this.imgError=true
     
    }
  },
  mounted:function(){
    
    this.bgUrl=this.src;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.no-img{
color:#CCCCCC;
}

.footer{

  padding:20px 0px;
  display:flex;
  justify-content: center;
}
.footer img{
  width:80%;
   max-width:250px;
   height:auto;
}
</style>
